import React from "react";
import { Search } from "@kelp-dao/kernel-design-system";

interface VaultSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder?: string;
  className?: string;
}

const VaultSearch: React.FC<VaultSearchProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = "Search",
  className = "max-w-[138px]",
}) => {
  return (
    <Search
      placeholder={placeholder}
      onSearch={onSearchChange}
      className={className}
      value={searchQuery}
    />
  );
};

export default VaultSearch;
